export class Enums
{  
  static getNames( enumValue:any ):string[]
  {
    let allKeys = Object.keys( enumValue );    
    let values = allKeys.filter( k => isNaN( Number( k ) )  );
    return values;
  }   

  static upperCaseEnumNameToJSNameOf( enumClass:any, index:number )
  {
    return Enums.upperCaseEnumNameToJSName( enumClass[ index ] );
  }

  static upperCaseEnumNameToJSName( name:string )
  {
    return name.toLowerCase().replace( /_/g, "-" );
  }

  
}